export enum BuildStatus {
  IDLE = 0,
  BUILDING = 1,
  READ_FOR_DOWNLOAD = 2,
  FAILED = 3,
}
